import { RECEIVE_SELF_EMPLOYMENT_ACTIVITIES, REQUEST_SELF_EMPLOYMENT_ACTIVITIES } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_SELF_EMPLOYMENT_ACTIVITIES:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_SELF_EMPLOYMENT_ACTIVITIES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
